export const sxCommonStyles = {
  fieldsWrapper: { display: 'flex', gap: '1.5rem', alignItems: 'start' },
};
